import React, { FunctionComponent, useState } from 'react'

import styled from 'styled-components/native'

import { ClientListClientObject } from '@lyrahealth-inc/shared-app-logic/src/models/client/ClientListClient'
import { BodyText } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/bodyText/BodyText'
import { PressableOpacity } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/pressableOpacity/PressableOpacity'
import { ThemeType } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/themes/ThemeProvider'
import { tID } from '@lyrahealth-inc/ui-core-crossplatform/src/utils/utils'

const HitContainer = styled(PressableOpacity)<{ theme: ThemeType; hoverIn: boolean; selected: boolean }>(
  ({ theme: { colors, spacing }, hoverIn, selected }) => ({
    height: '40px',
    paddingLeft: spacing['24px'],
    justifyContent: 'center',
    ...((selected || hoverIn) && { backgroundColor: colors.backgroundElement }),
  }),
)

type GoSearchModalClientHitProps = {
  onClick: () => void
  hit: ClientListClientObject
  selected?: boolean
}

export const GoSearchModalClientHit: FunctionComponent<GoSearchModalClientHitProps> = ({
  hit,
  selected = false,
  onClick,
}) => {
  const clientName = `${hit.first_name} ${hit.last_name}`
  const [hoverIn, setHoverIn] = useState(false)

  return (
    <HitContainer
      testID={tID(selected ? 'GoSearchClientHit-selected' : 'GoSearchClientHit')}
      key={hit.id}
      onHoverIn={() => setHoverIn(true)}
      onHoverOut={() => setHoverIn(false)}
      onPress={onClick}
      selected={selected}
      hoverIn={hoverIn}
    >
      <BodyText text={clientName} />
    </HitContainer>
  )
}
